import { useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ClickToTextViewStore } from 'pages/clickToText/store'
import { ClickToTextViewContext } from 'pages/clickToText/pages/viewClickToText/context'
import { ClickToTextViewContent } from 'pages/clickToText/pages/createClickToText/ui/ClickToTextViewContent'
import { useClickToTextPageContext } from 'pages/clickToText/context'

export const CreateClickToText = () => {
  const entities = useEntitiesContext()
  const clickToTextPageStore = useClickToTextPageContext()
  const store = useMemo(() => new ClickToTextViewStore(entities, clickToTextPageStore), [])

  return (
    <ClickToTextViewContext.Provider value={store}>
      <ClickToTextViewContent />
    </ClickToTextViewContext.Provider>
  )
}
